@if (item.visible==true || item.visible=='true') {
  <div class="float-left col-12 mBot15 p-0"
    [ngClass]="item.controlType=='composite-array' || item.controlType=='html-editor' || item.controlType=='editgrid' || item.controlType=='annotation' || item.controlType == 'dynamic-table'?'col-12':'col-3'"
    >
    <div class="col-12 p-0" id="{{item.name}}_ques">
      @if (item.controlType !== 'hidden' && item.controlType !== 'composite-array') {
        <label id="{{item.name}}_check" [attr.for]="item.name"
          class=" control-label col-12 pl-0">
          @if (item.label && item.view_label=='') {
            <span class="font-weight-bold" [innerHTML]="item.label | translate | async"
            >{{item.label | translate | async}}</span>
          }
          @if (item.view_label!='' && item.view_label) {
            <span class="font-weight-bold" [innerHTML]="item.view_label | translate | async"
            >{{item.view_label | translate | async}}</span>
          }
          @if (item.label == null) {
            <span> &nbsp;</span>
          }
        </label>
      }
      <!-- <label *ngIf="item.controlType == 'checkbox'" [attr.for]="item.name" class=" control-label">
    </label> -->
    @switch (item.controlType) {
      <!----------------------TextBox-------------------------------->
      @case ('textbox') {
        @if (item.value && item.value!='') {
          <div class="text-break col-12 pl-0" [ngClass]="!item.textCapitalize ? '': 'text-capitalize'">{{item.value}}</div>
        }
        @if (item.value== null ||item.value== undefined ||item.value== '') {
          <div class="col-12 pl-0"
          >{{'field.label.Not_filled' | translate | async }}</div>
        }
      }
      <!----------------------searchselect-------------------------------->
      @case ('searchselect') {
        <div class="text-break col-12 pl-0">{{getValueDropdown(item)}}</div>
      }
      <!----------------------DropDown------------------------------->
      @case ('dropdown') {
        <div class="control-label col-12 pl-0">{{getValueDropdown(item)}}</div>
      }
      <!----------------------Image viewer------------------------------->
      <!-- <ng-container *ngSwitchCase="'fileuploader'">
      <div *ngIf="item.value" class="control-label col-12">
        <img [src]="item.value | safeHtml" alt="{{item.name}}" width="500" height="500">
      </div>
    </ng-container> -->
    <!----------------------Text eDitor------------------------------->
    @case ('html-editor') {
      <ckeditor [(ngModel)]='item.value' [config]="ckeConfig">
      </ckeditor>
    }
    <!----------------------daterangepicker------------------------------->
    @case ('daterangepicker') {
      <!-- <input style="background-color: #ffffff!important;border: 0px!important;" type="text" [disableControl]="true" ngxDaterangepickerMd [id]="item.key" placeholder="Choose date" showCancel="true" [singleDatePicker]="item.singleDatePicker" [autoApply]="item.autoApply"
      [timePicker]="item.timePicker" [disableControl]="item.disabled" [locale]="item.locale" [timePickerSeconds]="item.timePickerSeconds" [timePicker24Hour]="item.timePicker24Hour" [minDateNumber]="item.minDateNumber" [minDateUnit]="item.minDateUnit"
      [maxDateNumber]="item.maxDateNumber" [maxDateUnit]="item.maxDateUnit" [timePickerIncrement]="item.timePickerIncrement" [outPutFormat]="item.outPutFormat" [showDropdowns]="item.showDropdowns" [(ngModel)]="item.value" autocomplete="off"
      /> -->
      <date-time-view [value]="item.value" [id]="item.key" [type]='item.type'
      [outPutFormat]='item.outPutFormat'></date-time-view>
    }
    <!--------------- timePicker --------------------------------------------->
    @case ('timepicker') {
      @if (item.value && item.value!='') {
        <div class="control-label col-12 pl-0">{{ item.value ? (item.value
        | timeFormat) : ''}}</div>
      }
      @if (item.value== null ||item.value== undefined ||item.value== '') {
        <div class="control-label col-12 pl-0"
          >Not
        filled</div>
      }
    }
    <!----------------------fileuploader-------End------->
    @case ('fileuploader') {
      <dhs-file-uploader [id]="item.key" [multiple]="item.multiple"
        [formatsAllowed]="item.formatsAllowed" [maxSize]="item.maxSize" [resource]="item.resource"
        [formAction]="item.formAction" [question]="item" [value]="item.value">
      </dhs-file-uploader>
    }
    <!-----------------------Gird inside a form -------Start------->
    @case ('formwithgrid') {
      <kx-form-with-grid [dataResource]="item.dataResource" [action]="current_action" [data]="item.data"
        [value]="item.value" [pagination]="item.pagination">
      </kx-form-with-grid>
    }
    <!----------------------checkbox------------------------------->
    @case ('checkbox') {
      @if (item.value!=undefined && item.view_key !=undefined && !item.format) {
        <div class="control-label col-12 pl-0">
        {{item.view_key[item.value]}}</div>
      }
      @if (item.value!=undefined && item.view_key ==undefined && !item.format) {
        <div class="control-label col-12 pl-0">
        {{item.value}}</div>
      }
      @if (item.value!=undefined  && item.format) {
        <div class="control-label col-12 pl-0">
        {{getValueForCheckbox(data, item.format)}}</div>
      }
      @if (item.value== undefined) {
        <div class="control-label col-12 pl-0" >Not
          filled
        </div>
      }
    }
    <!----------------------Image Annotation------------------------------->
    @case ('annotation') {
      <app-document-with-thumbnail [datasource]="item.datasource" [question]="item" [value]="item.value">
      </app-document-with-thumbnail>
    }
    <!----------------------rating------------------------------->
    @case ('rating') {
      @if (item.value!=undefined) {
        <div class="control-label col-12 pl-0">
          <dhs-rating [value]="item.value" [req_stars]="item.req_stars"></dhs-rating>
        </div>
      }
      @if (item.value== undefined) {
        <div class="control-label col-12 pl-0" >Not
          filled
        </div>
      }
    }
    <!----------------------tickets------------------------------->
    @case ('tickets') {
      @if (item.value!=undefined) {
        <div class="control-label col-12 pl-0">
          <dhs-tickets [value]="item.value"></dhs-tickets>
        </div>
      }
      @if (item.value== undefined) {
        <div class="control-label col-12 pl-0" >Not
          filled
        </div>
      }
    }
    <!----------------------signature------------------------------->
    @case ('signature') {
      @if (item.value && item.value !== '') {
        <div class="control-label col-12 pl-0">
          <img [src]="item.value" [alt]="item.label || item.name" class="img-fluid" style="max-width: 500px; max-height: 500px;">
        </div>
      }
      @if (item.value == null || item.value == undefined || item.value == '') {
        <div class="control-label col-12 pl-0">
          Not filled
        </div>
      }
    }
    <!----------------------Default------------------------------->
    @default {
      @if (item.value!==undefined && item.value!==null&& item.value!=='' && item.type != 'datetime') {
        <div class="control-label col-12 pl-0"
        >{{item.value}}</div>
      }
      @if (item.type == 'datetime') {
        <div class="control-label col-12 pl-0">{{item.value ? (item.value |
        dateTimeFormat) : ''}}</div>
      }
      @if (item.value=== null ||item.value=== undefined ||item.value=== '') {
        <div class="control-label col-12 pl-0"
          >Not
        filled</div>
      }
    }
    @case ('composite-array') {
      <dhs-composite-array [items]="item.value" [id]="item.key" [resource]="item.resource"
        [current_action]="'VIEW'" [question]="item">
      </dhs-composite-array>
    }
    @case ('pullable') {
      @if (item.fields == undefined && item.value!=undefined && item.value!='' && item.value.length > 0) {
        <div>
          <dhs-composite-array [items]="parse(item.value)" [id]="item.key"
            [resource]="item.pullableData.resource" [current_action]="'VIEW'">
          </dhs-composite-array>
        </div>
      }
      @if (item.fields != undefined && item.value!=undefined && item.value!='' && item.value.length > 0) {
        <div>
          @if (item.value!=undefined && item.value!='' && item.value.length > 0 && item.fields) {
            <dhs-data-grid
              [data]="{resource:item.value}" [fields]="item.fields" [config]="dataGridConfig">
            </dhs-data-grid>
          }
        </div>
      }
      @if (item.value== null ||item.value== undefined ||item.value== '' || item.value.length == 0) {
        <div class="control-label col-12 pl-0"
        >{{'field.label.Not_filled' | translate | async }}</div>
      }
    }
    @case ('editable-table') {
      <dhs-editable-table [id]="item.key" [minWidth]="item.minWidth" [resource]="item.resource"
        [datasource]="item.datasource" [items]="item.value" [dependentField]="item.dependentField"
        [fieldDataSource]="item.fieldDataSource" [current_action]="'VIEW'" [parentItem]="data">
      </dhs-editable-table>
    }
    @case ('editgrid') {
      @if (item.fields) {
        <data-table [fields]="item.fields" [data]="item.value"></data-table>
      }
    }
    @case ('button') {
    }
    @case ('monthYearPicker') {
      <kx-month-year-view [value]="item.value" [id]="item.key" [type]='item.type'></kx-month-year-view>
    }
    <!-- added by tina- to complete the requirement of radio button in view as before there is showing id of button-->
    @case ('radio') {
      <div class="kx-radio-main-wrapper">
        @for (option of item.options; track option) {
          @if (item.value===option.id) {
            <label class="kx-radio-wrapper mr-3">
              {{option.value}}
              <input type="radio" [(ngModel)]='item.value' [value]="option.id" [id]="option.id" disabled>
              <span class="kx-radio-check"></span>
            </label>
          }
        }
      </div>
    }
    @case ('dynamic-table') {
      @if (item.fields && item.dynamicTablevalue!=undefined) {
        <data-table [fields]="item.fields"
        [data]="item.dynamicTablevalue"></data-table>
      }
    }
  }
</div>
</div>
}